import type { IconData } from '@stacksjs/iconify-core'

export const angleUp: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16.243 15.121a1 1 0 0 1-.707-.293L12 11.293l-3.536 3.535a1 1 0 0 1-1.414-1.414l4.243-4.242a1 1 0 0 1 1.414 0l4.243 4.242a1 1 0 0 1-.707 1.707\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default angleUp
